import { Box } from "@mui/material";
import React, { useEffect } from "react";
import StlapFooter from "../CustomComponents/StlapFooter";
import SecurityChequeFilter from "./SecurityChequeFilter";
import { SecurityChequeReducerAction } from "../Store/SecurityCheque/SecurityChequeReducer";
import { useDispatch } from "react-redux";

const SecurityCheque = (props) => {
  //Creating Dispatch
  const dispatch = useDispatch();
  useEffect(() => {
    // on url change component unmount by navigating by side menu.
    return () => {
      dispatch(SecurityChequeReducerAction.resetFilterValues());
      dispatch(SecurityChequeReducerAction.resetFileDetailsData());
      dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(false));
      dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(false));
      dispatch(SecurityChequeReducerAction.resetChequeListGridRows());
      dispatch(SecurityChequeReducerAction.resetFileDetailsData());
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );

      // remove all the touch handlers.
      dispatch(SecurityChequeReducerAction.resetAllTouchHandlers());
    };
  }, [props.screenMode]);
  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <SecurityChequeFilter screenMode={props.screenMode} />
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
};

export default SecurityCheque;
